module.exports = __webpack_public_path__ + "img/danger.9d140ac4.svg";